import { features } from '@/mocks/categories';

export default function FeatureCards() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Why Thousands Of Shoppers Use Sugargoo Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Join a growing community of international shoppers who save time and money with our curated resources.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-accent-100/80 flex items-center justify-center mb-4 group-hover:bg-accent-200/80 transition-colors duration-300">
                <i className={`${feature.icon} text-lg md:text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}